import React, { FunctionComponent, ReactElement, useReducer } from 'react';
import { deviceDetection } from '../dispatch-methoods/deviceChecker';

export interface IPageState {
  prevUrl?: string;
  prevUri?: string;
  origin?: string;
  currentUrl: string;
  currentUri: string;
  currentLanguage: string;
}

export interface ICookieData {
  buttonCta: string;
  agreementText: string;
}
export interface IAppState {
  showGridHelper: boolean;
  showActiveDevice: number | null;
  showPageState: IPageState;
  isLoading: boolean;
  cookieSection: ICookieData;
}

export interface IProviderValue {
  state: IAppState;
  dispatch: (action: IAppAction) => void;
}
export interface IAppAction {
  type: AppActionType;
  payload?: number | string | IPageState | ICookieData;
}

export enum AppActionType {
  toggleGridHelper,
  deviceSize,
  pageState,
  loading,
  stopLoading,
  cookieData
}

const reducer = (state: IAppState, action: IAppAction): IAppState => {
  switch (action.type) {
    case AppActionType.toggleGridHelper:
      return { ...state, showGridHelper: !state.showGridHelper };
    case AppActionType.deviceSize:
      return { ...state, showActiveDevice: deviceDetection(action.payload) };
    case AppActionType.pageState:
      return { ...state, showPageState: { ...action.payload } };
    case AppActionType.loading:
      return { ...state, isLoading: true };
    case AppActionType.stopLoading:
      return { ...state, isLoading: false };
    case AppActionType.cookieData:
      return {
        ...state,
        cookieSection: { ...(action.payload as ICookieData) }
      };
  }
};

const initialState: IAppState = {
  showGridHelper: true,
  showActiveDevice: null,
  showPageState: {
    origin: '',
    prevUrl: '',
    currentUrl: '',
    currentUri: '',
    currentLanguage: ''
  },
  isLoading: false,
  cookieSection: {
    buttonCta: 'Accept',
    agreementText:
      'As part of our website we use cookies to provide you with services at the highest level, including in a manner tailored to individual needs. Using the site whithout changing the cookies settings means that they will be stored in your device. You can changes settings at any time.'
  }
};

export const AppStore = React.createContext({} as IProviderValue);

export const AppStoreProvider: FunctionComponent<React.PropsWithChildren<{}>> = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppStore.Provider value={{ state, dispatch }}>
      {props.children}
    </AppStore.Provider>
  );
};

export function withAppStore(Component: FunctionComponent): FunctionComponent {
  const AppStoreWrapper: FunctionComponent<{}> = (props): ReactElement => (
    <>
      <AppStoreProvider>
        <Component {...props} />
      </AppStoreProvider>
    </>
  );
  return AppStoreWrapper;
}
